import React, { CSSProperties, useEffect, useState } from "react";
import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import { isLocal, isDev } from "../../utils/env";

const style: CSSProperties = {
  backgroundColor: "orange",
  color: "white",
  top: 0,
};

export default function EnvHeader() {
  const [envText, setEnvText] = useState("");

  useEffect(() => {
    if (isDev) {
      setEnvText("QA");
    }
    if (isLocal) {
      setEnvText("Local");
    }
  }, []);

  if (!envText) {
    return null;
  }

  return (
    <Container fluid style={style}>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="env-tooltip">
            Currently logged into the
            <br />
            {envText.toUpperCase()}
            <br />
            environment
          </Tooltip>
        }
      >
        <Row className="w-100" id="env-tooltip">
          <Col className="text-center">
            <h6 className="text-white pt-2">{envText} ENV</h6>
          </Col>
        </Row>
      </OverlayTrigger>
    </Container>
  );
}
